export default function OnboardingTooltip({
  index,
  size,
  step,
  backProps,
  primaryProps,
  skipProps,
  tooltipProps,
  isLastStep,
}) {
  return (
    <div
      {...tooltipProps}
      className="max-w-[320px] rounded-[12px] border border-border-primary bg-white p-4 shadow-lg"
    >
      {step.title && (
        <div className="mb-1 text-sm font-semibold text-text-primary">
          {step.title}
        </div>
      )}
      <div className="mb-4 text-sm text-text-secondary">{step.content}</div>
      <div className="flex items-center justify-between">
        <span className="text-xs text-text-secondary">
          {index + 1} / {size}
        </span>
        <div className="flex items-center gap-2">
          <button
            {...skipProps}
            className="text-xs font-medium text-text-secondary hover:text-text-primary"
          >
            Skip
          </button>
          {index > 0 && (
            <button
              {...backProps}
              className="rounded-full border border-border-primary px-3 py-1.5 text-xs font-semibold text-text-primary"
            >
              Back
            </button>
          )}
          <button
            {...primaryProps}
            className="rounded-full bg-primary px-3 py-1.5 text-xs font-semibold text-white hover:bg-[#2684d1]"
          >
            {isLastStep ? "Done" : "Next"}
          </button>
        </div>
      </div>
    </div>
  );
}
